import "regenerator-runtime/runtime";
import _asyncToGenerator from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import { getToken, getAutToken, removeToken, setToken, setAutToken, getTopic, removeTopic, setTopic, getJsTopic, removeJsTopic, setJsTopic } from '@/utils/auth';
import router, { resetRouter } from '@/router';
import { Dialog } from 'vant';
import { MessageBox } from 'element-ui';
import { getOrgIdListByUserApi, getUserInfoApi,
// getDataByOrgIdAndShrNameApi,
loginByPasswordApi, authenticationApi, logoutApi, loginByWeChatApi, loginByCodeApi, getTopicApi, jsGetTopicApi, getAuthenticationApi } from '@/api/baseApp/user';
import { loginApi } from '@/api/outsideService/index';
import { checkOS } from '@/utils/system';
var state = {
  token: getToken() ? getToken() : getAutToken(),
  name: '',
  userId: '',
  avatar: '',
  deptId: '',
  userType: '',
  buildId: '',
  companyId: '',
  companyName: '',
  mobile: '',
  roles: [],
  buttons: [],
  email: '',
  deptList: [],
  shrBuildId: '',
  topic: getTopic(),
  jsTopic: getJsTopic()
};
var mutations = {
  SET_TOKEN: function SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_NAME: function SET_NAME(state, name) {
    state.name = name;
  },
  SET_USER_ID: function SET_USER_ID(state, userId) {
    state.userId = userId;
  },
  SET_AVATAR: function SET_AVATAR(state, avatar) {
    state.avatar = avatar;
  },
  SET_ROLES: function SET_ROLES(state, roles) {
    state.roles = roles;
  },
  SET_BUTTONS: function SET_BUTTONS(state, buttons) {
    state.buttons = buttons;
  },
  SET_DEPT: function SET_DEPT(state, deptId) {
    state.deptId = deptId;
  },
  SET_COMPANY: function SET_COMPANY(state, companyName) {
    state.companyName = companyName;
  },
  SET_MOBILE: function SET_MOBILE(state, mobile) {
    state.mobile = mobile;
  },
  SET_EMAIL: function SET_EMAIL(state, email) {
    state.email = email;
  },
  SET_DEPT_LIST: function SET_DEPT_LIST(state, deptList) {
    state.deptList = deptList;
  },
  SET_BUILD_ID: function SET_BUILD_ID(state, buildId) {
    state.buildId = buildId;
  },
  SET_COMPANY_ID: function SET_COMPANY_ID(state, companyId) {
    state.companyId = companyId;
  },
  SET_USER_TYPE: function SET_USER_TYPE(state, userType) {
    state.userType = userType;
  },
  SET_TOPIC: function SET_TOPIC(state, topic) {
    state.topic = topic;
  },
  SET_JS_TOPIC: function SET_JS_TOPIC(state, jsTopic) {
    state.jsTopic = jsTopic;
  }
  // SET_SEWAGE_BUILDID: (state, shrBuildId) => {
  //   state.shrBuildId = shrBuildId
  // }
};
var actions = {
  // user login
  login: function login(_ref, userInfo) {
    var commit = _ref.commit;
    var username = userInfo.username,
      password = userInfo.password;
    return new Promise(function (resolve, reject) {
      loginByPasswordApi({
        username: username.trim(),
        password: password
      }).then(function (res) {
        var data = res.data;
        commit('SET_TOKEN', data);
        setToken(data);
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // sso login by code
  ssoLogin: function ssoLogin(_ref2, code) {
    var commit = _ref2.commit;
    console.log('ssoLogin->code', code);
    return new Promise(function (resolve, reject) {
      authenticationApi({
        code: code
      }).then(function (res) {
        var data = res.data;
        commit('SET_TOKEN', data);
        setToken(data);
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  loginByWeChat: function loginByWeChat(_ref3, params) {
    var commit = _ref3.commit;
    return new Promise(function (resolve, reject) {
      loginByWeChatApi(params).then(function (response) {
        var data = response.data;
        if (data) {
          commit('SET_TOKEN', data);
          setToken(data);
        }
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  loginByCode: function loginByCode(_ref4, params) {
    var commit = _ref4.commit;
    return new Promise(function (resolve, reject) {
      loginByCodeApi(params).then(function (response) {
        var data = response.data;
        if (data) {
          commit('SET_TOKEN', data);
          setToken(data);
        }
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getLoginCode: function getLoginCode(_ref5, params) {
    var commit = _ref5.commit;
    return new Promise(function (resolve, reject) {
      loginApi(params).then(function (res) {
        if (res.data) {
          commit('SET_TOKEN', res.data.outToken);
          setAutToken(res.data.outToken);
        }
        resolve(res.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // get user info
  getInfo: function getInfo(_ref6) {
    var commit = _ref6.commit,
      state = _ref6.state;
    return new Promise(function (resolve, reject) {
      getUserInfoApi().then(function (response) {
        var data = response.data;
        if (!data) {
          reject('Verification failed, please Login again.');
        }
        var userId = data.userId,
          roleIdList = data.roleIdList,
          realName = data.realName,
          deptId = data.deptId,
          telephone = data.telephone,
          email = data.email,
          avatar = data.avatar,
          buildId = data.buildId,
          companyId = data.companyId,
          userType = data.userType;
        // roles must be a non-empty array
        if (!roleIdList) {
          if (checkOS() !== 'pc') {
            Dialog.alert({
              message: '无权限，请联系管理员'
            }).then();
          } else {
            MessageBox.alert('无权限，请联系管理员', '警告', {
              confirmButtonText: '确定'
            }).then();
          }
          reject('无权限，请联系管理员');
        }
        commit('SET_ROLES', roleIdList);
        commit('SET_USER_ID', userId);
        commit('SET_USER_TYPE', userType);
        commit('SET_NAME', realName);
        commit('SET_COMPANY_ID', companyId);
        if (avatar) {
          commit('SET_AVATAR', avatar);
        } else {
          commit('SET_AVATAR', 'https://alphaxbo.dlg-property.com/util/file/preview?name=dc3e0633-5587-4435-a1a0-b7d8e14d64a5.png&path=/home/httpd/FM/user/image');
        }
        commit('SET_DEPT', deptId);
        commit('SET_MOBILE', telephone);
        commit('SET_EMAIL', email);
        commit('SET_BUILD_ID', buildId);
        getOrgIdListByUserApi({
          id: userId
        }).then(function (res) {
          commit('SET_DEPT_LIST', res.data);
        });
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // user logout
  logout: function logout(_ref7) {
    var commit = _ref7.commit,
      state = _ref7.state,
      dispatch = _ref7.dispatch;
    return new Promise(function (resolve, reject) {
      logoutApi().then(function () {
        commit('SET_TOKEN', '');
        commit('SET_TOPIC', '');
        commit('SET_JS_TOPIC', '');
        commit('SET_ROLES', []);
        removeToken();
        removeTopic();
        resetRouter();
        removeJsTopic();
        // reset visited views and cached views
        // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
        dispatch('tagsView/delAllViews', null, {
          root: true
        });
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // remove token
  resetToken: function resetToken(_ref8) {
    var commit = _ref8.commit;
    return new Promise(function (resolve) {
      commit('SET_TOKEN', '');
      commit('SET_ROLES', []);
      commit('SET_TOPIC', '');
      commit('SET_JS_TOPIC', '');
      removeToken();
      removeTopic();
      resolve();
    });
  },
  // dynamically modify permissions
  changeRoles: function changeRoles(_ref9, role) {
    var commit = _ref9.commit,
      dispatch = _ref9.dispatch;
    return new Promise( /*#__PURE__*/function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(resolve) {
        var token, _yield$dispatch, roles, accessRoutes;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              token = role + '-token';
              commit('SET_TOKEN', token);
              setToken(token);
              _context.next = 5;
              return dispatch('getInfo');
            case 5:
              _yield$dispatch = _context.sent;
              roles = _yield$dispatch.roles;
              resetRouter();

              // generate accessible routes map based on roles
              _context.next = 10;
              return dispatch('permission/generateRoutes', roles, {
                root: true
              });
            case 10:
              accessRoutes = _context.sent;
              // dynamically add accessible routes
              router.addRoutes(accessRoutes);

              // reset visited views and cached views
              dispatch('tagsView/delAllViews', null, {
                root: true
              });
              resolve();
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref10.apply(this, arguments);
      };
    }());
  },
  getTopic: function getTopic(_ref11, role) {
    var commit = _ref11.commit,
      dispatch = _ref11.dispatch;
    return new Promise(function (resolve, reject) {
      getTopicApi().then(function (res) {
        var data = res.data;
        commit('SET_TOPIC', data);
        setTopic(data);
        resolve();
      }).catch(function () {
        commit('SET_TOPIC', '');
      });
    });
  },
  jsGetTopic: function jsGetTopic(_ref12, role) {
    var commit = _ref12.commit,
      dispatch = _ref12.dispatch;
    return new Promise(function (resolve, reject) {
      jsGetTopicApi().then(function (res) {
        var data = res.data;
        if (data == null) {
          // 久事topic
          commit('SET_JS_TOPIC', null);
          // 使用同一个topic
          commit('SET_TOPIC', null);
        } else {
          commit('SET_JS_TOPIC', data);
          commit('SET_TOPIC', data);
        }
        setJsTopic(data);
        setTopic(data);
        resolve();
      }).catch(function () {
        commit('SET_JS_TOPIC', '');
        commit('SET_TOPIC', '');
      });
    });
  },
  // sewage
  // get user info
  // getDataByOrgIdAndShrName({ commit }, orgList) {
  //   return new Promise((resolve, reject) => {
  //     getDataByOrgIdAndShrNameApi(orgList).then(response => {
  //       const { data } = response
  //       commit('SET_SEWAGE_BUILDID', data.shrBuildId)
  //       resolve()
  //     }).catch(error => {
  //       reject(error)
  //     })
  //   })
  // }
  authLogin: function authLogin(_ref13, data) {
    var commit = _ref13.commit;
    console.log('authLogin->code', data);
    return new Promise(function (resolve, reject) {
      getAuthenticationApi(data).then(function (res) {
        var data = res.data;
        commit('SET_TOKEN', data);
        setToken(data);
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};